import { IApprovalSystemState } from "../types";

const state = (): IApprovalSystemState => ({
  approvalWorkflows: [],
  selectedApprovalWorkflow: null,
  isFetchingApprovalWorkflows: false,
  isFetchingApprovalWorkflowDetail: false,
  approvalWorkflowActionLoading: false,
});

export default state;
